import { FuelCard, FuelIcon, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { DS_TOKENS } from 'constants/styled.contants';
import { TLastSarchedDriversProps } from 'open-search/types';
import React, { FC } from 'react';
import DriverInfo from './DriverInfo';
import * as Styled from './styled';

const LastSearchedDrivers: FC<TLastSarchedDriversProps> = ({ lastSearchedDrivers, openProfile }) => (
  <Styled.Wrapper data-testid="open-search-last-searched-drivers">
    <FuelCard backgroundColor={DS_TOKENS.color.background.neutral.default}>
      <Styled.ContentWrapper slot="content">
        <FuelFlex
          defaultProps={{
            alignItems: 'center',
            justifyContent: 'flex-start',
            gap: 'km2',
            customPadding: `${DS_TOKENS.spacing.km0} ${DS_TOKENS.spacing.km2} ${DS_TOKENS.spacing.km4}`,
          }}
        >
          <FuelIcon name="clock" size="small" />
          <FuelTypography size="body-sm" color="neutral-default" weight="regular">
            Últimas pré-consultas
          </FuelTypography>
        </FuelFlex>
        {lastSearchedDrivers?.map((driver, index) => (
          <DriverInfo
            key={driver.id}
            driverInfo={driver}
            showDivider={lastSearchedDrivers?.length !== index + 1}
            onClick={/* istanbul ignore next */ () => openProfile(driver)}
          />
        ))}
      </Styled.ContentWrapper>
    </FuelCard>
  </Styled.Wrapper>
);

export default LastSearchedDrivers;
